import { memo } from 'react';

import LoginPopupPresentation from './LoginPopup.presentation';
import useLoginPopup, { Props as LoginPopupHookProps } from './useLoginPopup';

type Props = LoginPopupHookProps;

const LoginPopupBindings = (props: Props): React.JSX.Element => {
  const [state, handlers] = useLoginPopup(props);
  return <LoginPopupPresentation handlers={handlers} state={state} />;
};

export default memo(LoginPopupBindings);
